import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "state";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <Auth0Provider
        domain="dev-isokinder.us.auth0.com"
        clientId="ayyJhAJcJU1U20NzewI2gFyBfljHs4Lw"
        authorizationParams={{
          redirect_uri: window.location.origin,
        }}
      >
        <Provider store={store}> */}
      <App />
      {/* </Provider>
      </Auth0Provider> */}
    </BrowserRouter>
  </React.StrictMode>
);
